/**
 * Routes. Everything but the login page sits behind `<RequireAuth>` inside `<AppShell>`, including
 * the failure pages, which keep the menu so a wrong turn stays recoverable. Report routes come from
 * `reports/registry.tsx` one per report, so an unknown id falls through to not-found.
 *
 * **`basename` is required, not decorative.** The bundle is served from a path prefix; without it
 * every URL the router produces drops that prefix and 404s when refreshed or shared, defeating
 * §4.4. It reads `import.meta.env.BASE_URL` so the prefix is stated once, in `vite.config.ts`.
 */

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AuthProvider } from '@/components/auth/AuthProvider';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { AppShell } from '@/components/layout/AppShell';
import LoginPage from '@/pages/LoginPage';
import NotAuthorisedPage from '@/pages/NotAuthorisedPage';
import NotFoundPage from '@/pages/NotFoundPage';
import OverviewPage from '@/pages/OverviewPage';
import { REPORT_ROUTES } from '@/reports/registry';
import { I18nProvider } from '@/lib/i18n';

export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <AuthProvider>
        <I18nProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route index element={<OverviewPage />} />
            {REPORT_ROUTES.map(({ reportId, element }) => (
              <Route key={reportId} path={`reports/${reportId}`} element={element} />
            ))}
            <Route path="not-authorised" element={<NotAuthorisedPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
